{
  "CHAT_LIST": {
    "LOADING": "Отримання бесід",
    "LOAD_MORE_CONVERSATIONS": "Завантажити більше бесід",
    "EOF": "Всі бесіди завантажені 🎉",
    "LIST": {
      "404": "В цій групі немає активних бесід."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Бесіди",
    "MENTION_HEADING": "Згадування",
    "UNATTENDED_HEADING": "Без відповіді",
    "SEARCH": {
      "INPUT": "Пошук людей, чатів та збережених відповідей.."
    },
    "FILTER_ALL": "Всі",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Мої",
      "unassigned": "Непризначені",
      "all": "Всі"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Відкриті"
      },
      "resolved": {
        "TEXT": "Вирішені"
      },
      "pending": {
        "TEXT": "Очікує"
      },
      "snoozed": {
        "TEXT": "Відкладено"
      },
      "all": {
        "TEXT": "Всі"
      }
    },
    "VIEW_FILTER": "Вигляд",
    "SORT_TOOLTIP_LABEL": "Відсортувати розмови",
    "CHAT_SORT": {
      "STATUS": "Статус",
      "ORDER_BY": "Сортувати за"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Створено",
      "LAST_ACTIVITY": "Остання активність:",
      "LAST_CUSTOMER_MESSAGE": "Останнє повідомлення клієнта:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Остання активність: спочатку старіші"
      },
      "last_activity_at_desc": {
        "TEXT": "Остання активність: спочатку нові"
      },
      "created_at_desc": {
        "TEXT": "Створено: спочатку нові"
      },
      "created_at_asc": {
        "TEXT": "Створено у: спочатку старіші"
      },
      "priority_desc": {
        "TEXT": "Пріоритет: спочатку найвищий"
      },
      "priority_asc": {
        "TEXT": "Пріоритет: спочатку низький"
      },
      "waiting_since_asc": {
        "TEXT": "Очікує відповіді: спочатку довгі"
      },
      "waiting_since_desc": {
        "TEXT": "Очікує відповіді: спершу короткі"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Останнє повідомлення клієнта: спочатку старіші"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Останнє повідомлення клієнта: спочатку новіші"
      },
      "priority_created_at_desc": {
        "TEXT": "Пріоритет + дата створення: спочатку новіші"
      },
      "priority_created_at_asc": {
        "TEXT": "Пріоритет + дата створення: спочатку старіші"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Повідомлення з картинкою"
      },
      "audio": {
        "CONTENT": "Аудіо-повідомлення"
      },
      "video": {
        "CONTENT": "Відеоповідомлення"
      },
      "file": {
        "CONTENT": "Повідомлення з файлом"
      },
      "location": {
        "CONTENT": "Місцезнаходження"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "поділився посиланням"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Відсортувати розмови",
      "DROPDOWN_TITLE": "Сортувати за",
      "ITEMS": {
        "LATEST": {
          "NAME": "Остання активність о",
          "LABEL": "Остання активність"
        },
        "CREATED_AT": {
          "NAME": "Створений в",
          "LABEL": "Створений в"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Дата останнього повідомлення",
          "LABEL": "Останнє повідомлення"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Отримано електронною поштою",
    "VIEW_TWEET_IN_TWITTER": "Переглянути твіт у Twitter",
    "REPLY_TO_TWEET": "Відповісти на цей твіт",
    "LINK_TO_STORY": "Перейти до історії Instagram",
    "SENT": "Успішно надіслано",
    "READ": "Успішно прочитано",
    "DELIVERED": "Успішно доставлено",
    "NO_MESSAGES": "Немає повідомлень",
    "NO_CONTENT": "Немає вмісту",
    "HIDE_QUOTED_TEXT": "Приховати цитований текст",
    "SHOW_QUOTED_TEXT": "Показати цитований текст",
    "MESSAGE_READ": "Прочитано",
    "SENDING": "Sending",
    "SEARCH_MESSAGES": "Пошук розмов",
    "SEARCH_INPUT_PLACEHOLDER": "Пошук розмов...",
    "MESSAGE_USE_AS_TEMPLATE": "Вставити у відповідь",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Відкрити",
        "BUY": "Купити"
      }
    },
    "HIDE_AUTOMATED_MESSAGE": "Приховати вміст автоматичної відповіді",
    "SHOW_AUTOMATED_MESSAGE": "Показати вміст автоматичної відповіді",
    "AUTOMATED_MESSAGE": "Автоматична відповідь"
  }
}
